import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "none",
  viewBox: "0 0 49.8 34.8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M-.1 17.4h50",
  "vector-effect": "non-scaling-stroke"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  d: "m16.9 34.4-17-17 17-17",
  "vector-effect": "non-scaling-stroke"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }